module.exports = require('@bugsnag/browser')
module.exports = require('@bugsnag/browser')
